import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { environment } from 'src/environments/environment';

import { BehaviorSubject } from 'rxjs';
import { isNil } from 'src/utils/utils';

export const MODULES = [
  CommonModule,
  MatIconModule,
  MatButtonModule,
  MatListModule,
  TranslateModule,
];
export const DIRECTIVES = [CdkDrag, CdkDragHandle];

/**
 *
 * TODO: This file is extracted from Intern-FE-Components. When angular upgraded to version 16, can be replaced.
 *
 * Styles Panel component. This component is responsible for allowing selection on mapbox map styles. It should be used
 * together with `MatDialog`.
 * The component that instantiates it should subscribe and unsubscribe from `activeItem$`.
 *
 */
@Component({
  selector: 'app-styles-panel',
  templateUrl: './styles-panel.component.html',
  styleUrls: ['./styles-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [...MODULES, ...DIRECTIVES, FaIconComponent],
})
export class StylesPanelComponent implements OnInit {
  private dialogRef = inject(MatDialogRef<StylesPanelComponent>);
  @Inject(MAT_DIALOG_DATA)
  public data: { localStorageId: string } = inject(MAT_DIALOG_DATA);

  mapLayers = environment.mapbox.layers;
  selectedLayerStyle = new BehaviorSubject<{
    name: string;
    style: string;
  } | null>(null);
  selectedLayerStyle$ = this.selectedLayerStyle.asObservable();

  ngOnInit(): void {
    this.initActiveMapLayer();
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  public initActiveMapLayer() {
    const savedMapLayerName = localStorage.getItem(this.data.localStorageId);
    if (!isNil(savedMapLayerName)) {
      const savedMapLayer = this.mapLayers.find(
        mapLayer => mapLayer.name === savedMapLayerName
      );
      this.setActiveMapLayer(savedMapLayer ?? this.mapLayers[0]);
    } else {
      this.setActiveMapLayer(this.mapLayers[0]);
    }
  }

  setActiveMapLayer(mapLayer: { name: string; style: string }): void {
    this.selectedLayerStyle.next(mapLayer);
    localStorage.setItem(this.data.localStorageId, mapLayer.name);
  }
}
